export default "__VITE_ASSET__f6e3dc95__"